<template>
  <div>
    <table width="100%" border="0">
      <tr>
        <td
          v-for="(color, index) in colors()"
          :key="index"
          v-bind:style="getBackgroundColor(index)"
        >
          <br />
        </td>
      </tr>
    </table>

    <table width="100%" border="0">
      <tr>
        <td>
          <small>{{ leastPreferred() }}</small>
        </td>
        <td align="right">
          <small>{{ mostPreferred() }}</small>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  props: ["forceNumbers"],
  data: function() {
    return {};
  },
  computed: {
    getScenario() {
      return this.$store.getters.getScenarioInCurrentLocale;
    }
  },
  mounted() {},
  methods: {
    leastPreferred() {
      if (this.$store.state.main.showPriorityLabels || this.forceNumbers) {
        return " (1) " + this.getScenario.self_evaluation_unpreferred;
      } else {
        return this.getScenario.self_evaluation_unpreferred;
      }
    },
    mostPreferred() {
      if (this.$store.state.main.showPriorityLabels || this.forceNumbers) {
        return (
          this.getScenario.self_evaluation_preferred +
          " (" +
          this.$store.getters.getNumberOfCases +
          ")"
        );
      } else {
        return this.getScenario.self_evaluation_preferred;
      }
    },
    getBackgroundColor(index) {
      // Let's swap the order
      const colorCount = this.$store.state.main.colors.length;
      return "background-color: " + this.$store.state.main.colors[colorCount - 1 - index];
    },
    colors() {
      return this.$store.state.main.colors;
    }
  }
};
</script>
